t = require('app/scripts/views/internal/teacup-with-helpers')('popover_selector_menu')

module.exports = t.renderable ({ isTemplate }) ->
  t.ul '.pop-over-list', ->
    if !isTemplate
      t.li ->
        t.a '.js-mem-selector', { href: '#' }, ->
          t.format 'members-ellipsis'
    t.li ->
      t.a '.js-label-selector', { href: '#' }, ->
        t.format 'labels-ellipsis'
    t.li ->
      t.a '.js-pos-selector', { href: '#' }, ->
        t.format 'position-ellipsis'
